import * as z from "zod";

export const updateTicketValidationStatus = {
  name: "updateTicketValidationStatus" as const,
  input: z.object({
    linearTicketId: z.string(),
    newStatus: z.enum(["approved", "rejected"]),
  }),
  output: z.object({ success: z.boolean(), updatedCount: z.number() }),
};
